import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: []
})

export class PaginationComponent implements OnInit {
  @Input() totalPages;
  @Input() pageNumber;
  @Input() pageSize;

  @Output() getData: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void { }

  nextPage() {
    if (this.pageNumber < this.totalPages) {
      ++this.pageNumber;
      this.getData.emit(this.pageNumber);
    }
  }

  previousPage() {
    if (this.pageNumber > 0) {
      --this.pageNumber;
      this.getData.emit(this.pageNumber);
    }
  }

  firstPage() {
    this.pageNumber = 1;
    this.getData.emit(this.pageNumber);
  }

  lastPage() {
    this.pageNumber = this.totalPages;
    this.getData.emit(this.pageNumber);
  }

}

